import { LogLevel, TelemetryEvent } from "../../common/telemetry/TelemetryConstants";
import React, { useEffect } from "react";
import { createTimer, findAllFocusableElement } from "../../common/utils";
import { LoadingPane } from "@microsoft/omnichannel-chat-components";
import { TelemetryHelper } from "../../common/telemetry/TelemetryHelper";
import { defaultGeneralPostChatLoadingPaneStyleProps } from "./common/defaultgeneralPostChatLoadingPaneStyleProps";
import useChatContextStore from "../../hooks/useChatContextStore";
let uiTimer;
export const PostChatLoadingPaneStateful = props => {
  var _props$styleProps;
  useEffect(() => {
    uiTimer = createTimer();
    TelemetryHelper.logLoadingEvent(LogLevel.INFO, {
      Event: TelemetryEvent.UXPostChatLoadingPaneStart
    });
  }, []);
  const [state] = useChatContextStore();
  const generalStyleProps = Object.assign({}, defaultGeneralPostChatLoadingPaneStyleProps, (_props$styleProps = props.styleProps) === null || _props$styleProps === void 0 ? void 0 : _props$styleProps.generalStyleProps);
  const styleProps = {
    ...props.styleProps,
    generalStyleProps: generalStyleProps
  };
  const controlProps = {
    id: "oc-lcw-postchatloading-pane",
    dir: state.domainStates.globalDir,
    hideIcon: true,
    hideTitle: true,
    hideSpinner: true,
    hideSpinnerText: true,
    subtitleText: "Please take a moment to give us feedback about your chat experience. We are loading the survey for you now.",
    ...props.controlProps
  };

  // Move focus to the first button
  useEffect(() => {
    const firstElement = findAllFocusableElement(`#${state.domainStates.widgetElementId}`);
    if (firstElement && firstElement[0]) {
      firstElement[0].focus();
    }
    TelemetryHelper.logLoadingEvent(LogLevel.INFO, {
      Event: TelemetryEvent.PostChatSurveyLoadingPaneLoaded
    });
    TelemetryHelper.logLoadingEvent(LogLevel.INFO, {
      Event: TelemetryEvent.UXPostChatLoadingPaneCompleted,
      ElapsedTimeInMilliseconds: uiTimer.milliSecondsElapsed
    });
  }, []);
  return /*#__PURE__*/React.createElement(LoadingPane, {
    componentOverrides: props.componentOverrides,
    controlProps: controlProps,
    styleProps: styleProps
  });
};
export default PostChatLoadingPaneStateful;